<template>
    <div class="calendar-wrapper">
        <Calendar :first-instance="firstInstance" :last-instance="lastInstance" :available-months="JSON.parse(availableMonths)" />
    </div>
</template>

<script>
    import Calendar from "./components/Calendar"

    export default {
        name: "App",
        props: ['firstInstance', 'lastInstance', 'availableMonths'],
        components: {
            Calendar
        }
    }
</script>

<style scoped>

</style>
